var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"has-text-centered"},[_vm._v(_vm._s(this.time))])
}
var staticRenderFns = []

export { render, staticRenderFns }